export default {
    state: {
        serviceNotificationList: []
    },
    mutations: {
        receiveServiceChangedMessage(state, payload){
            if(state.currentService && state.currentService.id === payload.id){
                return
            }

            let notificationIndex = state.serviceNotificationList.findIndex(item => item.id === payload.id)
            if(notificationIndex > -1){
                state.serviceNotificationList.splice(notificationIndex, 1)
            }
            state.serviceNotificationList.unshift(payload)
        },
        removeServiceChangedMessage(state, payload){
            let notificationIndex = state.serviceNotificationList.findIndex(item => item.id === payload)
            if(notificationIndex > -1){
                state.serviceNotificationList.splice(notificationIndex, 1)
            }
        },
        clearNotification(state){
            state.serviceNotificationList = []
        }
    },
    actions: {
        receiveServiceChangedMessage(context, payload){
            context.commit('receiveServiceChangedMessage', payload)
        },
        removeServiceChangedMessage(context, payload){
            return new Promise((resolve) => {
                context.commit('removeServiceChangedMessage', payload)
                resolve()
            })
        },
        receiveServiceRemovedMessage(context, payload){
            context.commit('receiveServiceRemovedMessage', payload)
        },
        clearNotification(context){
            context.commit('clearNotification')
        }
    },
    getters: {
        serviceChangedNotification(state){
            return state.serviceNotificationList
        }
    }
}